import { forwardRef, type Ref, type SVGProps } from "react";

function SvgEmail(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 83 83" {...props}>
      <path
        fill="currentColor"
        d="M76.083 20.75c0-3.804-3.112-6.917-6.916-6.917H13.833c-3.804 0-6.916 3.113-6.916 6.917v41.5c0 3.804 3.112 6.917 6.916 6.917h55.334c3.804 0 6.916-3.113 6.916-6.917zm-6.916 0L41.5 38.007 13.833 20.75zm0 41.5H13.833V27.667L41.5 44.958l27.667-17.291z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgEmail);
export default ForwardRef;
